import type { ReactNode } from 'react';
import React from 'react';
import type { ViewProps } from 'react-native';
import { View, Platform } from 'react-native';

type ListProps = {
  readonly children: ReactNode;
} & ViewProps;

/**
 * List
 */
export const List = React.memo((props: ListProps) => {
  const { children, ...rest } = props;

  return (
    <View
      {...(Platform.OS === 'web' ? { accessibilityRole: 'list' } : {})}
      {...rest}
    >
      {children}
    </View>
  );
});

export const ListItem = React.memo((props: ListProps) => {
  const { children, ...rest } = props;

  return (
    <View
      {...(Platform.OS === 'web' ? { accessibilityRole: 'listitem' } : {})}
      {...rest}
    >
      {children}
    </View>
  );
});
